/**
 * Public settings hook - reads /public/settings (cached in module).
 */
import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let inflight = null;

export function usePublicSettings() {
    const [settings, setSettings] = useState(cached);
    useEffect(() => {
        if (cached) return;
        if (!inflight) {
            inflight = api.get("/public/settings").then((r) => {
                cached = r.data;
                return r.data;
            }).catch(() => null);
        }
        inflight.then((data) => { if (data) setSettings(data); });
    }, []);
    return settings;
}
